import { Link } from 'react-router-dom';
function HomeAdmin({fullName}) {
  const links = new Set();
  links.add({ path: "/submittedforms", label: "RECEIVED FORMS" });
  links.add({ path: "/allpeople", label: "OUR PEOPLE" });
  links.add({ path: "/allevents", label: "EVENT GALLERY" });
  return (
    <main className="flex flex-col items-center p-4">
      <div className="w-full border-b border-gray-200 flex flex-col text-center">
        <p className="text-xs sm:text-sm text-gray-400">Welcome</p>
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-400 mb-2">
          {fullName}
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-4 mt-4">
        {[...links].map((link, index) => (
          <Link key={index} to={link.path}>
            <div className="w-[150px] h-[150px] bg-gradient-to-r from-blue-400 to-blue-200 text-gray-800 p-2 rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-400 hover:text-white transition-all cursor-pointer flex items-center justify-center text-center text-xs">
              {link.label}
            </div>
          </Link>
        ))}
      </div>
    </main>
    )
  }
  
  export default HomeAdmin